module.exports = __webpack_public_path__ + "img/alexis_nihon.8eba7299.webp";